export default {
  loading: false,
  cancelRequest: null,
  SearchTerm: '',
  CurrentSearch: '',
  SortOrder: '',
  SortOrderOptions: [],
  Tag: '',
  filters: [],
  ShowFilters: true,
  items: [],
  itemsRemaining: 0,
  itemsCount: 0,
  From: 0,
  Take: 0,
  initialTake: 0,
  currentPage: 1,
  totalPages: 1,
  parentId: null,
  childItemsOnly: false,
  isSiteSearch: false,
  showNoResultsContent: false,
  url: '/umbraco/api/search/items',
  urlSortOrder: '/umbraco/api/search/sortOrders',
  urlTagSearch: '/umbraco/api/tagresultssearch/items'
}